export const locales = {
  "errorLabel": {
    "Context": "Message displayed on error screen",
    "en": "There was an error loading this page.",
    "cy": "Roedd gwall wrth lwytho'r dudalen hon.",
    "it": "Si è verificato un errore nel caricare la pagina.",
    "fr": "Nous avons rencontré une erreur en chargeant cette page.",
    "de": "Beim Laden dieser Seite ist ein Fehler aufgetreten",
    "es": "Ha habido un error al cargar esta página.",
    "ca": "Hi ha hagut un error en carregar la pàgina",
    "nl": "Fout bij het laden van de pagina",
    "da": "Fejl ved indlæsning af side",
    "pt-BR": "Ocorreu um erro carregando esta página",
    "ru": "При загрузке этой страницы произошла ошибка."
  },
  "goBack": {
    "Context": "Button label for going back to library if an error occurs",
    "en": "Go Back",
    "cy": "Yn ôl",
    "it": "Indietro",
    "fr": "Revenir en arrière",
    "de": "geh zurück",
    "es": "Volver atrás",
    "ca": "Tornar enrera",
    "nl": "Ga terug",
    "da": "Gå tilbage",
    "pt-BR": "Voltar",
    "ru": "Вернуться"
  },
  "tryAgain": {
    "Context": "Button label for reloading the page if an error occurs",
    "en": "Try Again",
    "cy": "Trio eto",
    "it": "Riprova",
    "fr": "Réessayer",
    "de": "bitte nochmals versuchen",
    "es": "Intentar de nuevo",
    "ca": "Provar de nou",
    "nl": "Probeer opnieuw",
    "da": "Prøv igen",
    "pt-BR": "Tente novamente",
    "ru": "Попробуйте снова"
  },
  "": {
    "Context": "",
    "en": "",
    "cy": "",
    "it": "",
    "fr": "",
    "de": "",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "tosDefault": {
    "Context": "Default label for Terms of Service link – will be used if none is configured in Rails",
    "en": "Terms of Service",
    "cy": "Telerau Gwasanaeth",
    "it": "Condizioni d'utilizzo",
    "fr": "Conditions d’utilisation",
    "de": "Impressum",
    "es": "Condiciones del servicio",
    "ca": "Condicions del servei",
    "nl": "Algemene voorwaarden",
    "da": "Servicebetingelser",
    "pt-BR": "Termos de uso",
    "ru": "Условия Пользования"
  },
  "scrollingSuggestion": {
    "Context": "Message for people using a screen reader, inviting them to use scroll mode for better compatibility",
    "en": "We recommend scrolling mode for use with screen readers and keyboard navigation.\r\nGo to settings to switch to scrolling mode.",
    "cy": "Rydym yn argymell sgrolio",
    "it": "Raccomandiamo l'uso della modalità a scorrimento con screen reader e navigazione da tastiera. Vai nella sezione “Preferenze” per cambiare modalità.",
    "fr": "Il est recommandé d’utilisé le mode Défilé dans les préférences si vous utilisez un lecteur d’écran ou naviguez au clavier.",
    "de": "Wir empfehlen den Bildlaufmodus für Bildschirmlesegeräte und für die Navigation mit der Tastatur. Unter der Option Einstellungen, ist es möglich den Bildlaufmodus zu wechseln.",
    "es": "Recomendamos el modo desplazamiento si usted utiliza un lector de pantalla o navega con el teclado. Vaya a ajustes para cambiar a modo desplazamiento.",
    "ca": "Recomanem el mode de desplaçament si utilitza un lector de pantalla o navega amb el teclat. Vagi a Ajustos per canviar a mode de desplaçament.",
    "nl": "Kies Scrollen in plaats van Per pagina bij gebruik van een screen reader met toetsenbordnavigatie. Ga naar Instellingen om dit aan te passen.",
    "da": "Scrolle-tilstand anbefales til skærmlæsning og navigation vha. tastatur. Gå til indstillinger og slå scrolle-tilstand til.",
    "pt-BR": "Recomendamos acionar modo de Rolagem para usuários utilizando leitores de tela ou navegação pelo teclado. Acesse as configurações e altere para modo Rolagem",
    "ru": "Мы рекомендуем использовать режим прокрутки для чтения с экранным считывающим устройством и навигации по клавиатуре.\r\nЗайдите в настройки, чтобы перейти в режим прокрутки."
  },
  "controlPanel": {
    "Context": "Label of the rotating hamburger button for screen readers",
    "en": "Controls",
    "cy": "Rheoli",
    "it": "Controlli",
    "fr": "Contrôles",
    "de": "Bedienfeld",
    "es": "Tabla de control",
    "ca": "Taula de control",
    "nl": "Instellingen",
    "da": "Kontrolpanel",
    "pt-BR": "Controles",
    "ru": "Инструменты"
  },
  "contents": {
    "Context": "Label displayed for the Contents panel (toc + bookmarks + annotations/highlights)",
    "en": "Contents",
    "cy": "Cynnwys",
    "it": "Contenuti",
    "fr": "Contenu",
    "de": "Inhalt",
    "es": "Contenido",
    "ca": "Continguts",
    "nl": "Inhoud",
    "da": "Indhold",
    "pt-BR": "Conteúdo",
    "ru": "Cодержание"
  },
  "toc": {
    "Context": "Label for the Table of Contents tab on desktop/tablet",
    "en": "Table of Contents",
    "cy": "Tabl Cynnwys",
    "it": "Sommario",
    "fr": "Table des matières",
    "de": "Inhaltsverzeichnis",
    "es": "Tabla de contenidos",
    "ca": "Taula de continguts",
    "nl": "Inhoudsopgave",
    "da": "Indholdsfortegnelse",
    "pt-BR": "Sumário",
    "ru": "Оглавление"
  },
  "settings": {
    "Context": "Label displayed next to the Settings icon on desktop/tablet",
    "en": "Settings",
    "cy": "Gosodiadau",
    "it": "Preferenze",
    "fr": "Préférences",
    "de": "Einstellungen",
    "es": "Ajustes",
    "ca": "Ajustos",
    "nl": "Instellingen",
    "da": "Indstillinger",
    "pt-BR": "Configuração",
    "ru": "Настройки"
  },
  "upLinkDefault": {
    "Context": "Label displayed next to Library/Cloud icon on desktop/tablet",
    "en": "My Books",
    "cy": "Fy Llyfrau",
    "it": "I miei libri",
    "fr": "Mes livres",
    "de": "Meine Bücher",
    "es": "Mis libros",
    "ca": "Els meus llibres",
    "nl": "Mijn boeken",
    "da": "Mine bøger",
    "pt-BR": "Meus livros",
    "ru": "Мои Книги"
  },
  "Fullscreen": {
    "Context": "Maximizes viewing area to occupy the full display",
    "en": "Fullscreen",
    "cy": "sgrin lawn",
    "it": "",
    "fr": "plein écran",
    "de": "Vollbild",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "previousChapter": {
    "Context": "Label displayed in scroll mode only, to navigate to the previous chapter",
    "en": "Previous Chapter",
    "cy": "Pennod Flaenorol",
    "it": "Capitolo Precedente",
    "fr": "Chapitre précédent",
    "de": "Vorheriges Kapitel",
    "es": "Capítulo anterior",
    "ca": "Capítol anterior",
    "nl": "Vorige hoofdstuk",
    "da": "Forrige kapitel",
    "pt-BR": "Capítulo anterior",
    "ru": "Предыдущая глава"
  },
  "previousPage": {
    "Context": "Popover/screen reader text for previous chevron (turning pages) / UI label in FXL bottom bar",
    "en": "Previous Page",
    "cy": "Tudalen Flaenorol",
    "it": "Pagina Precedente",
    "fr": "Page précédente",
    "de": "Vorherige Seite",
    "es": "Página anterior",
    "ca": "Pàgina anterior",
    "nl": "Vorige pagina",
    "da": "Forrige side",
    "pt-BR": "Página anterior",
    "ru": "Предыдущая страница"
  },
  "nextChapter": {
    "Context": "Label displayed in scroll mode only, to navigate to the next chapter",
    "en": "Next Chapter",
    "cy": "Pennod Nesaf",
    "it": "Capitolo Successivo",
    "fr": "Chapitre suivant",
    "de": "Nächstes Kapitel",
    "es": "Capítulo siguiente",
    "ca": "Capítol següent",
    "nl": "Volgende hoofdstuk",
    "da": "Næste kapitel",
    "pt-BR": "Próximo capítulo",
    "ru": "Следующая глава"
  },
  "nextPage": {
    "Context": "Popover/screen reader text for next chevron (turning pages) / UI label in FXL bottom bar",
    "en": "Next Page",
    "cy": "Tudalen Nesaf",
    "it": "Prossima Pagina",
    "fr": "Page suivante",
    "de": "Nächste Seite",
    "es": "Página siguiente",
    "ca": "Pàgina següent",
    "nl": "Volgende pagina",
    "da": "Næste side",
    "pt-BR": "Próxima página",
    "ru": "Следующая Страница"
  },
  "chapters": {
    "Context": "Displayed at the bottom of the UI when in Scrolling Mode on smartphones",
    "en": "Chapters",
    "cy": "Penodau",
    "it": "Capitoli",
    "fr": "Chapitres",
    "de": "Kapitel",
    "es": "Capítulos",
    "ca": "Capítols",
    "nl": "Hoofdstukken",
    "da": "Kapitel",
    "pt-BR": "Capítulos",
    "ru": "Главы"
  },
  "pages": {
    "Context": "Displayed at the bottom of the FXL UI when menus are shown",
    "en": "Pages",
    "cy": "Tudalennau",
    "it": "Pagine",
    "fr": "Pages",
    "de": "Seiten",
    "es": "Pages",
    "ca": "Pàgines",
    "nl": "Pagina's",
    "da": "Side",
    "pt-BR": "Páginas",
    "ru": "страницы"
  },
  "cacheUncached": {
    "Context": "",
    "en": "",
    "cy": "",
    "it": "",
    "fr": "",
    "de": "",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "cacheUpdateAvailable": {
    "Context": "Message displayed for offlining contents, when there is an update available",
    "en": "A new version is available. Refresh to update.",
    "cy": "Mae fersiwn newydd ar gael. Adfywio i ddiweddaru.",
    "it": "È disponibile una nuova versione. Ricarica la pagina per aggiornare.",
    "fr": "Rafraichissez la page pour télécharger la nouvelle version.",
    "de": "Eine neue Version ist verfügbar. Bitte die Seite aktualiseren.",
    "es": "Hay una nueva versión disponible, pulse actualizar para descargarla.",
    "ca": "Hi ha una nova versió disponible. Premi actualitzar per descarregar-la.",
    "nl": "Er is een nieuwe versie beschikbaar. Ververs om bij te werken",
    "da": "En ny version er tilgængelig. Opdater venligst.",
    "pt-BR": "Uma nova versão está disponível. Recarregue para atualizar.",
    "ru": "Доступна новая версия. Перезагрузите страницу."
  },
  "cacheCheckingUpdate": {
    "Context": "Message displayed for offlining contents, when checking for an update",
    "en": "Checking for update.",
    "cy": "Gwirio am ddiweddariad.",
    "it": "Controllo aggiornamenti in corso.",
    "fr": "Vérification des mises à jour.",
    "de": "Suche nach Updates.",
    "es": "Buscando actualizaciones.",
    "ca": "Buscant actualitzacions.",
    "nl": "Zoeken naar nieuwe versie...",
    "da": "Søger efter opdateringer.",
    "pt-BR": "Verificando por nova atualização",
    "ru": "Идет поиск обновления."
  },
  "cacheDownloading": {
    "Context": "Message displayed for offlining contents, when downloading contents in cache",
    "en": "Downloading...",
    "cy": "Lawrlwytho...",
    "it": "Caricamento...",
    "fr": "Téléchargement des contenus.",
    "de": "Wird heruntergeladen.",
    "es": "Cargando.",
    "ca": "Descarregant.",
    "nl": "Aan het downloaden...",
    "da": "Downloader...",
    "pt-BR": "Baixando",
    "ru": "Загрузка ..."
  },
  "cacheDownloaded": {
    "Context": "Message displayed for offlining contents, when contents are cached",
    "en": "Downloaded for offline use.",
    "cy": "Wedi'i lawrlwytho i'w ddefnyddio all-lein.",
    "it": "Salvato per uso offline.",
    "fr": "Livre téléchargé pour lecture hors-ligne.",
    "de": "Für den Offline-Gebrauch heruntergeladen.",
    "es": "Cargado para leer cuando el aparato esté fuera de cobertura.",
    "ca": "Descarregat per llegir-ho quan l'aparell estigui fora de cobertura.",
    "nl": "Opgeslagen voor offline gebruik",
    "da": "Downloader til offline brug.",
    "pt-BR": "Salvo para leitura sem internet",
    "ru": "Скачано для автономного использования."
  },
  "cacheError": {
    "Context": "Message displayed for offlining contents, when there is an error",
    "en": "Error downloading for offline use.",
    "cy": "Gwall wrth lawrlwytho i'w ddefnyddio all-lein.",
    "it": "Errore nel salvataggio per uso offline",
    "fr": "Nous avons rencontré une erreur. Ce livre ne sera pas disponible hors-ligne.",
    "de": "Ein Fehler ist aufgetreten beim Herunterladen für die Offline-Verwendung.",
    "es": "Error en la descarga para leer cuando el aparato esté fuera cobertura.",
    "ca": "Error durant la descàrrega per llegir fora de cobertura.",
    "nl": "Fout bij het downloaden voor offline gebruik",
    "da": "Der opstod en fejl under download til offline brug.",
    "pt-BR": "Erro ao baixar para leitura sem internet",
    "ru": "Ошибка загрузки для автономного использования."
  },
  "chapterTitle": {
    "Context": "Default string used if the current chapter doesn’t have a title, in progression at the bottom of the UI",
    "en": "Current Chapter",
    "cy": "Pennod bresennol",
    "it": "Capitolo corrente",
    "fr": "Chapitre en cours",
    "de": "Aktuelles Kapitel",
    "es": "Capítulo actual",
    "ca": "Capítol actual",
    "nl": "Huidige hoofdstuk",
    "da": "Nuværende kapitel",
    "pt-BR": "Capítulo atual",
    "ru": "Текущая глава"
  },
  "chapterPositionPage": {
    "Context": "Text used for the progression at the bottom of the UI, in the current chapter",
    "en": "Page",
    "cy": "Tudalen",
    "it": "Pagina",
    "fr": "Page",
    "de": "Seite",
    "es": "Página",
    "ca": "Pàgina",
    "nl": "Pagina",
    "da": "Side",
    "pt-BR": "Página",
    "ru": "Страница"
  },
  "chapterPositionOf": {
    "Context": "Text used for the progression at the bottom of the UI, in the current chapter",
    "en": "of",
    "cy": "o",
    "it": "di",
    "fr": "de",
    "de": "von",
    "es": "de",
    "ca": "de",
    "nl": "van",
    "da": "af",
    "pt-BR": "de",
    "ru": "из"
  },
  "bookFontPublisher": {
    "Context": "Label for Publisher font in settings",
    "en": "Publisher",
    "cy": "Cyhoeddwr",
    "it": "Editore",
    "fr": "(Police d’) Origine / Éditeur",
    "de": "Verlag",
    "es": "Editorial",
    "ca": "Editorial",
    "nl": "Origineel",
    "da": "Forlag",
    "pt-BR": "Editora",
    "ru": "Издатель"
  },
  "bookFontSerif": {
    "Context": "Label for Serif font in settings",
    "en": "Serif",
    "cy": "Serif",
    "it": "Serif",
    "fr": "(Police) Sérif / à empattements",
    "de": "Serif",
    "es": "Serif",
    "ca": "Serif",
    "nl": "Serif",
    "da": "Serif",
    "pt-BR": "Serifada",
    "ru": "С засечками"
  },
  "bookFontSans": {
    "Context": "Label for Sans Serif font in settings",
    "en": "Sans-serif",
    "cy": "Sans-serif",
    "it": "Sans-serif",
    "fr": "(Police) Sans-sérif / linéale",
    "de": "Serifenlos",
    "es": "Sans-serif",
    "ca": "Sans-serif",
    "nl": "Sans-serif",
    "da": "Sans-serif",
    "pt-BR": "Sem Serifas",
    "ru": "Без засечек"
  },
  "bookFontLexend": {
    "Context": "",
    "en": "Lexend",
    "cy": "Lexend",
    "it": "",
    "fr": "",
    "de": "Lexend",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookFontAtkinsonHyperlegible": {
    "Context": "",
    "en": "Atkinson Hyperlegible",
    "cy": "Atkinson Hyperlegible",
    "it": "",
    "fr": "",
    "de": "Atkinson Hyperlegible",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookFontOpenDyslexic": {
    "Context": "",
    "en": "Open Dyslexic",
    "cy": "Open Dyslexic",
    "it": "",
    "fr": "",
    "de": "Open Dyslexic",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "fontSizeDecrease": {
    "Context": "Label for Decreasing font size in settings",
    "en": "Aa-",
    "cy": "Aa-",
    "it": "Aa-",
    "fr": "Aa-",
    "de": "Aa-",
    "es": "Aa--",
    "ca": "Aa--",
    "nl": "Aa-",
    "da": "Aa-",
    "pt-BR": "Aa-",
    "ru": "Aa-"
  },
  "fontSizeIncrease": {
    "Context": "Label for Increasing font size in settings",
    "en": "Aa+",
    "cy": "Aa+",
    "it": "Aa+",
    "fr": "Aa+",
    "de": "Aa+",
    "es": "Aa+",
    "ca": "Aa+",
    "nl": "Aa+",
    "da": "Aa+",
    "pt-BR": "Aa+",
    "ru": "Aa+"
  },
  "bookThemeDay": {
    "Context": "Label for Day mode in settings",
    "en": "Day",
    "cy": "Dydd",
    "it": "Giorno",
    "fr": "Clair",
    "de": "Tag",
    "es": "Día",
    "ca": "Dia",
    "nl": "Overdag",
    "da": "Dag",
    "pt-BR": "Dia",
    "ru": "День"
  },
  "bookThemeSepia": {
    "Context": "Label for Sepia mode in settings",
    "en": "Sepia",
    "cy": "Sepia",
    "it": "Seppia",
    "fr": "Sépia",
    "de": "Sepia",
    "es": "Sepia",
    "ca": "Sèpia",
    "nl": "Sepia",
    "da": "Sepia",
    "pt-BR": "Acastanhado",
    "ru": "Сепия"
  },
  "bookThemeNight": {
    "Context": "Label for Night mode in settings",
    "en": "Night",
    "cy": "Nos",
    "it": "Notte",
    "fr": "Sombre / nuit",
    "de": "Nacht",
    "es": "Noche",
    "ca": "Nit",
    "nl": "Nacht",
    "da": "Nat",
    "pt-BR": "Noturno",
    "ru": "Ночь"
  },
  "bookViewPaginated": {
    "Context": "Label for Paginated mode in settings",
    "en": "Paginated",
    "cy": "Wedi'i dudalennu",
    "it": "Paginata",
    "fr": "Paginer",
    "de": "paginiert",
    "es": "Paginado",
    "ca": "Paginat",
    "nl": "Per pagina",
    "da": "Med sidetal",
    "pt-BR": "Paginado",
    "ru": "Нумерованный"
  },
  "bookViewScrolling": {
    "Context": "Label for scrolling mode in settings",
    "en": "Scrolling",
    "cy": "Sgrolio",
    "it": "A scorrimento",
    "fr": "Défiler",
    "de": "Scrollen",
    "es": "Desplazando",
    "ca": "Desplaçant",
    "nl": "Scrollen",
    "da": "Scrolle",
    "pt-BR": "Rolagem",
    "ru": "Прокрутка"
  },
  "preferredShop": {
    "Context": "Label for preferred shop submenu in settings",
    "en": "Preferred Bookstore",
    "cy": "Hoff Siop Lyfrau",
    "it": "Libreria Preferita",
    "fr": "Librairie Favorite",
    "de": "Bevorzugten Shop",
    "es": "Librería Preferida",
    "ca": "Llibreria Preferida (???)",
    "nl": "Voorkeursboekwinkel",
    "da": "Foretrukne boghandel",
    "pt-BR": "Livraria favorita",
    "ru": "Предпочитаемый книжный магазин"
  },
  "checkedIcon": {
    "Context": "Popover/screen reader text for checked icon e.g. selected settings",
    "en": "Checked",
    "cy": "Gwirwyd",
    "it": "Selezionato",
    "fr": "Sélectionné",
    "de": "ausgewählt",
    "es": "Seleccionado",
    "ca": "Seleccionat",
    "nl": "Geselecteerd",
    "da": "Valgt",
    "pt-BR": "Selecionado",
    "ru": "Включено"
  },
  "closeIcon": {
    "Context": "Popover/screen reader text for close icon e.g. toc and settings panel",
    "en": "Close",
    "cy": "Cau",
    "it": "Chiudi",
    "fr": "Fermer",
    "de": "schließen",
    "es": "Cerrar",
    "ca": "Tancat",
    "nl": "Sluiten",
    "da": "Luk",
    "pt-BR": "Fechar",
    "ru": "Закрыть"
  },
  "errorIcon": {
    "Context": "Popover/screen reader text for error icon on error screen",
    "en": "Warning",
    "cy": "Rhybudd",
    "it": "Attenzione",
    "fr": "Attention",
    "de": "Warnung",
    "es": "Advertencia",
    "ca": "Advertiment",
    "nl": "Waarschuwing",
    "da": "Advarsel",
    "pt-BR": "Alerta",
    "ru": "Предупреждение"
  },
  "expandIcon": {
    "Context": "Popover/screen reader text for entering fullscreen",
    "en": "Enter fullscreen",
    "cy": "Mynd i sgrin lawn",
    "it": "Entra in modalità a schermo intero",
    "fr": "Activer le mode plein écran",
    "de": "Vollbildmodus aktivieren",
    "es": "Activar modo pantalla completa",
    "ca": "Activar mode de pantalla completa",
    "nl": "Gebruik het volledige scherm",
    "da": "Vis fuldskærm",
    "pt-BR": "Ativar tela cheia",
    "ru": "Войти в полноэкранный режим\r\nSHORTER ALTERNATIVE:\r\nПолноэкранный режим"
  },
  "loadingIcon": {
    "Context": "Popover/screen reader text for loading animation",
    "en": "Loading",
    "cy": "Llwytho",
    "it": "Caricamento",
    "fr": "Chargement en cours",
    "de": "Laden",
    "es": "Cargando",
    "ca": "Carregant",
    "nl": "Aan het laden",
    "da": "Indlæser",
    "pt-BR": "Carregando",
    "ru": "Загрузка"
  },
  "menuIcon": {
    "Context": "Popover/screen reader text for rotating hamburger icon",
    "en": "Show and hide navigation bar",
    "cy": "Dangos a chuddio bar llywio",
    "it": "Mostra/nascondi barra di navigazione ",
    "fr": "Afficher et cacher le menu",
    "de": "Navigationsleiste ein- und ausblenden",
    "es": "Barra de mostrar y ocultar",
    "ca": "Barra de mostrar i amagar",
    "nl": "Toon/verberg navigatiemenu",
    "da": "Vis og skjul navigationsmenu",
    "pt-BR": "Exiba e oculta barra de navegação",
    "ru": "Показать и скрыть панель навигации"
  },
  "submenuIcon": {
    "Context": "Popover/screen reader text for submenu in settings panel",
    "en": "Show submenu",
    "cy": "Dangos yr is-ddewislen",
    "it": "Mostra menù secondario",
    "fr": "Afficher le sous-menu",
    "de": "Untermenü einblenden",
    "es": "Mostrar submenú",
    "ca": "Mostrar submenú",
    "nl": "Toon submenu",
    "da": "Vis undermenuer",
    "pt-BR": "Exibir submenu",
    "ru": "Показать подменю"
  },
  "minimizeIcon": {
    "Context": "Popover/screen reader text for exiting fullscreen",
    "en": "Exit fullscreen",
    "cy": "Gadael sgrin lawn",
    "it": "Esci dalla modalità a schermo intero",
    "fr": "Quitter le mode plein écran",
    "de": "Vollbildmodus verlassen",
    "es": "Salir del modo pantalla completa",
    "ca": "Sortir de mode de pantalla completa",
    "nl": "Sluit volledige schermmodus",
    "da": "Afslut fuldskærm",
    "pt-BR": "Saía do modo tela cheia",
    "ru": "Выход из полноэкранного режима"
  },
  "viewLockIcon": {
    "Context": "Popover/screen reader text for lock button (paginated/scrolling) in settings panel",
    "en": "Lock",
    "cy": "Cloi",
    "it": "Blocca",
    "fr": "Vérouiller",
    "de": "Gesperrt",
    "es": "Bloquar",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "enabled": {
    "Context": "Screen reader text for selected/active setting",
    "en": "enabled",
    "cy": "galluogwyd",
    "it": "Attivo",
    "fr": "activé",
    "de": "aktiviert",
    "es": "activado",
    "ca": "Activat",
    "nl": "actief",
    "da": "Slået til",
    "pt-BR": "ativo",
    "ru": "включено"
  },
  "disabled": {
    "Context": "Screen reader text for non-selected setting",
    "en": "disabled",
    "cy": "analluogwyd",
    "it": "Disattivo",
    "fr": "désactivé",
    "de": "deaktiviert",
    "es": "desactivado",
    "ca": "Desactivat",
    "nl": "inactief",
    "da": "Slået fra",
    "pt-BR": "inativo",
    "ru": "отключено"
  },
  "trackingOn": {
    "Context": "Text for the “enable data collection” button",
    "en": "Switch on data collection",
    "cy": "Trowch y broses casglu data ymlaen",
    "it": "Attiva collezione di dati",
    "fr": "Activer la collecte de données",
    "de": "Datenerfassung anschalten",
    "es": "Activar la recogida de archivos",
    "ca": "Activar la recollida de dades",
    "nl": "Gegevens verzamelen aanzetten",
    "da": "Slå dataindsamling til",
    "pt-BR": "Ativar compartilhamento de dados",
    "ru": "Включить сбор данных"
  },
  "trackingOff": {
    "Context": "Text for the “disable data collection” button",
    "en": "Switch off data collection",
    "cy": "Trowch y broses casglu data i ffwrdd",
    "it": "Disattiva collezione di dati",
    "fr": "Désactiver la collecte de données",
    "de": "Datenerfassung abschalten",
    "es": "Desactivar la recogida de archivos",
    "ca": "Desactivar la recollida de dades",
    "nl": "Gegevens verzamelen uitzetten",
    "da": "Slå dataindsamling fra",
    "pt-BR": "Desativar compartilhamento de dados",
    "ru": "Отключить сбор данных"
  },
  "aboutThisBook": {
    "Context": "Label for the settings’ button opening “About this Book” panel",
    "en": "About this book",
    "cy": "Am y llyfr hwn",
    "it": "Informazioni sul libro",
    "fr": "À propos de ce livre",
    "de": "Über dieses Buch\r\n",
    "es": "Sobre este libro",
    "ca": "Sobre aquest llibre",
    "nl": "Over dit boek",
    "da": "Om bogen",
    "pt-BR": "Sobre o livro",
    "ru": "Об этой книге"
  },
  "bookInfoPublisher": {
    "Context": "Text inserted before the publisher’s name in “About this Book” panel",
    "en": "Published by ",
    "cy": "Cyhoeddwyd gan",
    "it": "Pubblicato da",
    "fr": "Édité par",
    "de": "Erschienen bei",
    "es": "Publicado por",
    "ca": "Publicat per",
    "nl": "Uitgegeven door ",
    "da": "Udgivet af",
    "pt-BR": "Publicado por",
    "ru": "Издательство"
  },
  "bookInfoIsbn": {
    "Context": "Text inserted before the ISBN in “About this Book” panel",
    "en": "ISBN: ",
    "cy": "ISBN:",
    "it": "ISBN:",
    "fr": "ISBN: ",
    "de": "ISBN:",
    "es": "ISBN:",
    "ca": "ISBN:",
    "nl": "ISBN: ",
    "da": "ISBN:",
    "pt-BR": "ISBN:",
    "ru": "ISBN:"
  },
  "bookInfoGenre": {
    "Context": "Text inserted before the book’s genre in “About this Book” panel",
    "en": "Genre: ",
    "cy": "Genre:",
    "it": "Genere:",
    "fr": "Genre:",
    "de": "Kategorie:",
    "es": "Género:",
    "ca": "Gènere:",
    "nl": "Genre: ",
    "da": "Kategori:",
    "pt-BR": "Gênero",
    "ru": "Жанр:"
  },
  "bookInfoDate": {
    "Context": "Text inserted before the publication date in “About this Book” panel",
    "en": "Publication date: ",
    "cy": "Dyddiad Cyhoeddi:",
    "it": "Data di pubblicazione:",
    "fr": "Date de publication:",
    "de": "Veröffentlichungsdatum ",
    "es": "Fecha de publicación",
    "ca": "Data de publicació:",
    "nl": "Publicatiedatum: ",
    "da": "Udgivelsesdato:",
    "pt-BR": "Data de lançamento",
    "ru": "Дата публикации:"
  },
  "bookInfoBuy": {
    "Context": "Label of the “buy/Go to shop button” in “About this Book” panel",
    "en": "Buy this book",
    "cy": "Prynwch y llyfr hwn",
    "it": "Compra questo libro",
    "fr": "Acheter",
    "de": "Zum shop",
    "es": "Compre este libro",
    "ca": "Comprar aquest llibre",
    "nl": "Koop dit boek",
    "da": "Gå til shop (Køb)",
    "pt-BR": "Compre este livro",
    "ru": "Купить эту книгу"
  },
  "bookInfoShare": {
    "Context": "Label of the “Share button” in “About this Book” panel",
    "en": "Share",
    "cy": "Rhannu",
    "it": "Condividi",
    "fr": "Partager",
    "de": "Teilen",
    "es": "Compartir",
    "ca": "Compartir",
    "nl": "Delen",
    "da": "Del",
    "pt-BR": "Compartilhe",
    "ru": "Поделиться"
  },
  "bookInfoShareFallback": {
    "Context": "Label of the “Share button” when WebShare is not supported, and the text for twitter/facebook is copied in the clipboard – disappears after 5 seconds",
    "en": "Link copied",
    "cy": "dolen wedi'i chopïo",
    "it": "Link copiato",
    "fr": "Lien copié",
    "de": "Link wurde kopiert",
    "es": "Enlace copiado",
    "ca": "Enllaç copiat",
    "nl": "Link gekopieerd",
    "da": "Kopiér link",
    "pt-BR": "Link copiado",
    "ru": "Ссылка скопирована"
  },
  "bookInfoShareText": {
    "Context": "Default text used for the tweet/facebook message. Should probably contain title of the book",
    "en": "Here is a reading sample for a great book:",
    "cy": "Dyma sampl darllen ar gyfer llyfr arbennig:",
    "it": "Ecco un assaggio di un bel libro:",
    "fr": "Voici l’extrait d’un très bon livre:",
    "de": "Hier ist eine Leseprobe zu einem tollen Buch: ",
    "es": "Aquí tiene una muestra de un maravilloso libro:",
    "ca": "Aquí té una mostra d'un llibre meravellós: ",
    "nl": "Hier is een leesvoorbeeld van een mooi boek: ",
    "da": "Her er en læseprøve til en rigtig god bog: ",
    "pt-BR": "Aqui há uma amostra de um bom livro: ",
    "ru": "Вот отрывок из отличной книги:"
  },
  "libHandler": {
    "Context": "Popover/Aria label for “Add to Library” toggle",
    "en": "Add to My Books",
    "cy": "Ychwanegu at Fy Llyfrau",
    "it": "Aggiungi ai miei libri",
    "fr": "Ajouter à ma bibliothèque",
    "de": "In das Buchregal stellen",
    "es": "Incluir en mis libros",
    "ca": "",
    "nl": "",
    "da": "Tilføj til Mine bøger",
    "pt-BR": "Adicione para Meus livros",
    "ru": "Добавить в мои книги"
  },
  "libHint": {
    "Context": "Text of the hint to “add to bookshelf\" popping after 3 minutes",
    "en": "Click on cloud icon to save ebook for later reading.",
    "cy": "Cliciwch ar yr eicon cwmwl i arbed yr e-lyfr i'w ddarllen yn ddiweddarach.",
    "it": "",
    "fr": "Cliquez l’icône nuage pour ajouter ce livre à votre bibliothèque.",
    "de": "Klick auf das Wolkensymbol um das Ebook für späteres Lesen zu speichern",
    "es": "Click en el icono cloud para guardar el ebook para leerlo en otra ocasion. ",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "libAdded": {
    "Context": "Notification: sample was added to user’s personal library",
    "en": "This sample was added to your cloud library.",
    "cy": "Ychwanegwyd y sampl at eich llyfrgell-gwmwl.",
    "it": "Questo assaggio è stato aggiunto alla tua libreria.",
    "fr": "Cet extrait a été ajouté à votre bibliothèque.",
    "de": "Die Leseprobe wurde deinem Buchregal hinzugefügt.",
    "es": "Esta muestra ha sido incluida a tu libreria cloud.",
    "ca": "",
    "nl": "",
    "da": "Læseprøven blev føjet til dit bibliotek",
    "pt-BR": "Esta amostra foi adicionada para sua biblioteca na nuvem",
    "ru": "Этот отрывок был добавлен в вашу облачную библиотеку."
  },
  "libRemoved": {
    "Context": "Notification: sample was removed from user’s personal library",
    "en": "This sample was removed from your cloud library.",
    "cy": "Tynnwyd y sampl o'ch llyfrgell-gwmwl.",
    "it": "Questo assaggio è stato rimosso dalla tua libreria.",
    "fr": "Cet extrait a été effacé de votre bibliothèque.",
    "de": "Die Leseprobe wurde aus dem Buchregal entfernt.",
    "es": "Esta muestra ha sido removida de tu libreria cloud.",
    "ca": "",
    "nl": "",
    "da": "Læseprøven blev fjernet fra dit bibliotek",
    "pt-BR": "Esta amostra foi removida de sua biblioteca na nuvem",
    "ru": "Этот отрывок был удален из вашей облачной библиотеки."
  },
  "libExists": {
    "Context": "Notification: sample already exists in user’s personal library",
    "en": "This sample was already in your cloud library.",
    "cy": "Roedd y sampl eisoes yn eich llyfrgell-gwmwl.",
    "it": "Questo assaggio era già nella tua libreria.",
    "fr": "Cet extrait figurait déjà dans votre bibliothèque.",
    "de": "Die Leseprobe ist schon im Buchregal.",
    "es": "Esta muestra ya estaba en tu libreria cloud.",
    "ca": "",
    "nl": "",
    "da": "Læseprøven findes allerede i dit bibliotek",
    "pt-BR": "Esta amostra já se encontra em sua biblioteca na nuvem",
    "ru": "Этот отрывок уже был в вашей облачной библиотеке."
  },
  "libError": {
    "Context": "Notification: error when trying to add the sample to the user’s personal library",
    "en": "An error occured. Please try again later.",
    "cy": "Cafwyd gwall. Rhowch gynnig arni eto yn nes ymlaen.",
    "it": "Si è verificato un errore. Ti preghiamo di riprovare più tardi.",
    "fr": "Une erreur est survenue. Merci de réessayer plus tard.",
    "de": "Es ist ein Fehler aufgetreten. Bitte es später noch einmal probieren.",
    "es": "Ha ocurrido un error. Por favor, intente mas tarde.",
    "ca": "",
    "nl": "",
    "da": "Der skete en fejl, så læseprøven blev ikke føjet til biblioteket.",
    "pt-BR": "Ocorreu um erro. Tente novamente mais tarde.",
    "ru": "Произошла ошибка. Пожалуйста, попробуйте позже."
  },
  "spreadHint": {
    "Context": "Toast notification popping once for a FXL publication if it’s first open in portrait orientation and it has spreads",
    "en": "Try rotating or enlarging your browser for two-page spreads.",
    "cy": "Ceiswich droi neu ehangu eich porwr er mwyn gweld yr agoriad dwy dudalen.",
    "it": "Prova a ruotare lo schermo o ad allargare la finestra del browser per visualizzare due pagine contemporaneamente.",
    "fr": "Essayez de tourner ou agrandir votre navigateur pour afficher 2 pages.",
    "de": "Rotiere das Gerät oder vergrößere das Browserfenster für eine Zweiseitenansicht.",
    "es": "Intente rotar o enlargar su navegador para visualrisar dos paginas al mismo tiempo. ",
    "ca": "",
    "nl": "",
    "da": "Prøv at vende eller forstørre din browser til opslagsvisning.",
    "pt-BR": "",
    "ru": ""
  },
  "bookplateHint": {
    "Context": "Text of the Toast notification popping once when starting at an arbitrary chapter",
    "en": "The use of this eBook reader is governed by",
    "cy": "Mae defnydd o'r darllenydd E-lyfr hwn wedi ei reoli gan",
    "it": "La tua sessione di lettura sarà registrata.",
    "fr": "Votre session de lecture est enregistrée. ",
    "de": "Deine Lesedaten werden aufgezeichnet.",
    "es": "Tu lectura esta siendo grabada.",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookplateHintLink": {
    "Context": "Hyperlink text of the Toast notification popping once when starting at an arbitrary chapter",
    "en": "the Jellybooks T&Cs and privacy policy.",
    "cy": "delerau ac amodau a pholisi preifatrwydd Jellybooks.",
    "it": "Controlla quali dati sono raccolti.",
    "fr": "Voir les données collectées.",
    "de": "Siehe hier welche Daten aufgezeichnetw erden",
    "es": "Controla cual data es grabada.",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookMarginNarrow": {
    "Context": "",
    "en": "narrow",
    "cy": "cul",
    "it": "",
    "fr": "marges étroites",
    "de": "end",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookMarginMedium": {
    "Context": "",
    "en": "medium",
    "cy": "canolig",
    "it": "",
    "fr": "marges moyennes",
    "de": "normal",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookMarginWide": {
    "Context": "",
    "en": "wide ",
    "cy": "llydan",
    "it": "",
    "fr": "marges larges",
    "de": "weit",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "accessibilityModeDefault": {
    "Context": "",
    "en": "default",
    "cy": "rhagosodedig",
    "it": "",
    "fr": "Par défaut",
    "de": "Standard",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "accessibilityModeLowVision": {
    "Context": "",
    "en": "low vision/blind",
    "cy": "golwg isel/dall",
    "it": "",
    "fr": "Malvoyance",
    "de": "sehschwach/blind",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "accessibilityModeLexend": {
    "Context": "",
    "en": "dyslexia (Lexend)",
    "cy": "Dyslecsia (Lexend)",
    "it": "",
    "fr": "Dyslexie (Lexend)",
    "de": "Dyslexie (Lexend)",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "accessibilityModeOpenDyslexic": {
    "Context": "",
    "en": "dyslexia (Open Dyslexic)",
    "cy": "Dyslecsia (Open Dyslexic)",
    "it": "",
    "fr": "Dyslexie (OpenDyslexic)",
    "de": "Dyslecie (Open Dyslexic)",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "play": {
    "Context": "Popover/screen reader text for play button in audio controls",
    "en": "Play",
    "cy": "Chwarae",
    "it": "",
    "fr": "Lecture",
    "de": "Play",
    "es": "Leer",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "pause": {
    "Context": "Popover/screen reader text for pause button in audio controls",
    "en": "Pause",
    "cy": "saib",
    "it": "",
    "fr": "Pause",
    "de": "Pause",
    "es": "Pausa",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "skipBackward": {
    "Context": "Popover/screen reader text for skip backward button in audio controls",
    "en": "Rewind 30 seconds",
    "cy": "Ailweindiwch am 30 eiliad",
    "it": "",
    "fr": "Reculer de 30 secondes",
    "de": "30 Sekunden forwärts",
    "es": "Volver 30 segundos",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "skipForward": {
    "Context": "Popover/screen reader text for skip forward button in audio controls",
    "en": "Fast forward 30 seconds",
    "cy": "Ewch ymlaen am 30 eiliad",
    "it": "",
    "fr": "Avancer de 30 secondes",
    "de": "\r\n30 Sekunden zurück",
    "es": "Avansar 30 segundos",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "playbackRate": {
    "Context": "Popover/screen reader text for speed/playback rate button in audio controls",
    "en": "Speed",
    "cy": "Cyflymder",
    "it": "",
    "fr": "Vitesse de lecture",
    "de": "Wiedergabegeschwindigkeit",
    "es": "Velosidad de lectura",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookmarkPlaceholder": {
    "Context": "Text used if no chapter title can be found",
    "en": "Bookmark",
    "cy": "Llyfrnod",
    "it": "",
    "fr": "Signet",
    "de": "Lesezeichen",
    "es": "Marca",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookmark": {
    "Context": "Popover/screen reader text for bookmark button in audio controls",
    "en": "Add a bookmark",
    "cy": "Ychwanegu Llyfrnod",
    "it": "",
    "fr": "Ajouter un signet",
    "de": "Lesezeichen hinzufügen",
    "es": "Agregar un marcador",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookmarkExists": {
    "Context": "Text of the Toast notification popping when you add a bookmark but it already exists",
    "en": "Bookmark already exists",
    "cy": "Llyfrnod yn bodoli eisoes",
    "it": "",
    "fr": "Ce signet existe déjà",
    "de": "\r\nLesezeichen existiert",
    "es": "Marca ya existe",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookmarkSaved": {
    "Context": "Text of the Toast notification popping when you add a bookmark",
    "en": "Bookmark saved",
    "cy": "Llyfrnod wedi'i gadw",
    "it": "",
    "fr": "Signet enregistré",
    "de": "Lesezeichen gespeichert",
    "es": "Marca grabada",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookmarkDeleted": {
    "Context": "Text of the Toast notification popping when you delete a bookmark",
    "en": "Bookmark deleted",
    "cy": "Llyfrnod wedi'i ddileu",
    "it": "",
    "fr": "Signet effacé",
    "de": "Lesezeichen gelöscht",
    "es": "Marca borrada",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookmarks": {
    "Context": "Popover/screen reader text for bookmark button",
    "en": "Bookmarks",
    "cy": "Llyfrnodau",
    "it": "",
    "fr": "Signets",
    "de": "Lesezeichen",
    "es": "Marcas",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "sleepTimer": {
    "Context": "Popover/screen reader text for sleep timer button in audio controls",
    "en": "Sleep timer",
    "cy": "Amserydd cysgu",
    "it": "",
    "fr": "Minuteur de sommeil",
    "de": "Schlaf-Timer",
    "es": "Tiempo de dormir",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "delete": {
    "Context": "Popover/screen reader text for delete button",
    "en": "Delete",
    "cy": "Dileu",
    "it": "",
    "fr": "Effacer",
    "de": "\r\nlöschen",
    "es": "Borrar",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "dnt": {
    "Context": "Text for Do Not Track button in settings panel",
    "en": "Do not track",
    "cy": "Peidiwch â thracio",
    "it": "",
    "fr": "Désactiver le suivi",
    "de": "Datenaufzeichnung deaktivieren",
    "es": "No marcar",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "navigationError": {
    "Context": "Text of the Toast notification popping when there is a navigation error from a link within EPUB Contents",
    "en": "An error occurred when trying to navigate the publication.",
    "cy": "Digwyddodd gwall wrth drio llywio drwy'r cyhoeddiad.",
    "it": "",
    "fr": "Une erreur est survenue : le contenu demandé n’existe pas.",
    "de": "Ein Fehler ist in der Navigation aufgetreten",
    "es": "Un error ha acurrido. Contenido no existe.",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "tocNavError": {
    "Context": "Text of the Toast notification popping when there is a navigation error from the ToC panel",
    "en": "An error occurred when trying to reach the chapter from the Table of Contents.",
    "cy": "Digwyddodd gwall wrth drio cyrraedd y bennod o'r rhestr gynnwys.",
    "it": "",
    "fr": "Une erreur est survenue : l’entrée de la table des matières n’existe pas.",
    "de": "Ein Fehler ist aufgetreten beim Versuch das Kapitel vom Inhaltsverzeichnis aus zu erreichen",
    "es": "Un error ha acurrido. La entrada a la tabla de contenido no existe.",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "shareTitle": {
    "Context": "Text for the label of the Share menu",
    "en": "Share",
    "cy": "Rhannu",
    "it": "",
    "fr": "Partager",
    "de": "Teilen",
    "es": "Compartir",
    "ca": "",
    "nl": "Delen",
    "da": "Del",
    "pt-BR": "Compartilhar",
    "ru": "Поделиться"
  },
  "cancel": {
    "Context": "Text for the cancel button of the Share menu",
    "en": "Cancel",
    "cy": "Diddymu",
    "it": "",
    "fr": "Annuler",
    "de": "Abbrechen",
    "es": "Cancelar",
    "ca": "",
    "nl": "Annuleren",
    "da": "Luk",
    "pt-BR": "Cancelar",
    "ru": "Отмена"
  },
  "copy": {
    "Context": "Text for the copy button of the Share menu",
    "en": "Copy",
    "cy": "Copïo",
    "it": "",
    "fr": "Copier",
    "de": "Kopieren",
    "es": "Copiar",
    "ca": "",
    "nl": "Kopiëren",
    "da": "Kopiér",
    "pt-BR": "Copiar",
    "ru": "Скопировать"
  },
  "print": {
    "Context": "Text for the print button of the Share menu",
    "en": "Print",
    "cy": "Argraffu",
    "it": "",
    "fr": "Imprimer",
    "de": "Drucken",
    "es": "Imprimir",
    "ca": "",
    "nl": "Printen",
    "da": "Udskriv",
    "pt-BR": "Imprimir",
    "ru": "Печать"
  },
  "email": {
    "Context": "Text for the email button of the Share menu",
    "en": "E-mail",
    "cy": "E-bost",
    "it": "E-mail",
    "fr": "E-mail",
    "de": "E-mail",
    "es": "Correo",
    "ca": "",
    "nl": "E-mail",
    "da": "E-mail",
    "pt-BR": "E-mail",
    "ru": "Э-майл"
  },
  "selectSms": {
    "Context": "Text used as a placeholder when selecting a contact to send a SMS – when it works",
    "en": "Pick a contact",
    "cy": "Dewis Cyswllt",
    "it": "",
    "fr": "Veuillez choisir un contact",
    "de": "Wählen Sie einen Kontakt aus",
    "es": "Seleccionar un contacto",
    "ca": "",
    "nl": "Selecteer een contact",
    "da": "Vælg en kontaktperson",
    "pt-BR": "Selecione um contato",
    "ru": "Выбери контакт"
  },
  "miniTutorial": {
    "Context": "Label for the button that opens the minitutorial dialog",
    "en": "JellyBooks Cloud Reader Mini-Tutorial",
    "cy": "JellyBooks Tiwtorial Byr Cloud Reader",
    "it": "",
    "fr": "Mini-tutoriel",
    "de": "Jellybooks Cloud Reader Kurzanleitung",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "accessibilityMode": {
    "Context": "Label for drop down menu selecting accessibility mode",
    "en": "Accessibility Mode",
    "cy": "Hygyrchedd",
    "it": "",
    "fr": "Accessibilité",
    "de": "Barrierefreiheit",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "selectLanguage": {
    "Context": "Label for language menu",
    "en": "Language",
    "cy": "Iaith",
    "it": "",
    "fr": "Langue",
    "de": "Sprache",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "selectedFont": {
    "Context": "Label for font menu",
    "en": "Font",
    "cy": "Ffont",
    "it": "",
    "fr": "Police",
    "de": "Shriftart",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "selectedFontSize": {
    "Context": "Label for font size slider",
    "en": "Font Size",
    "cy": "Maint ffont",
    "it": "",
    "fr": "Taille de police",
    "de": "Schriftgröße",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "selectedLineHeight": {
    "Context": "Label for line spacing setting",
    "en": "Line Spacing",
    "cy": "Bylchau Llinellau",
    "it": "",
    "fr": "Interligne",
    "de": "Zeilenabstand",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "selectedMargin": {
    "Context": "Label for reading column width setting",
    "en": "Column Width",
    "cy": "Lled Colofn",
    "it": "",
    "fr": "Marges",
    "de": "Spaltenbreite",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "selectedMode": {
    "Context": "Label for the setting that lets you choose between scrolling and paginated",
    "en": "Mode",
    "cy": "Modd",
    "it": "",
    "fr": "Défilement",
    "de": "Modus",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "selectedGuide": {
    "Context": "Setting to toggle \"focus mode\" with reading guide",
    "en": "Focus Mode",
    "cy": "Modd Ffocws",
    "it": "",
    "fr": "Mode focus",
    "de": "Fokusmodus",
    "es": "",
    "ca": "",
    "nl": "",
    "da": "",
    "pt-BR": "",
    "ru": ""
  },
  "bookThemeAuto": {
    "Context": "Auto",
    "en": "Auto",
    "cy": "Auto",
    "it": "Auto",
    "fr": "Auto",
    "de": "Auto",
    "es": "Auto",
    "ca": "Auto",
    "nl": "Auto",
    "da": "Auto",
    "pt-BR": "Auto",
    "ru": "авто"
  },
  "bookTheme": {
    "Context": "Theme",
    "en": "Theme",
    "cy": "Theme",
    "it": "Tema",
    "fr": "Thème",
    "de": "Thema",
    "es": "Tema",
    "ca": "Tema",
    "nl": "Thema",
    "da": "Thema",
    "pt-BR": "Tema",
    "ru": "тема"
  },
  "unavailable": {
    "Context": "Not available.",
    "en": "Not available.",
    "cy": "Ddim ar gael",
    "it": "Not available.",
    "fr": "Not available.",
    "de": "Not available.",
    "es": "Not available.",
    "ca": "Not available.",
    "nl": "Not available.",
    "da": "Not available.",
    "pt-BR": "Not available.",
    "ru": "Not available."
  }
};